import mailPackage from './mailPackage'
import communityNotices from './communityNotices'
import paymentNotices from './paymentNotices'
import gasRegistration from './gasRegistration'
import serviceContact from './serviceContact'
import publicFacility from './publicFacility'

export default {
  // 郵件包裹
  ...mailPackage,
  // 社區公告
  ...communityNotices,
  // 繳費通知
  ...paymentNotices,
  // 瓦斯登記
  ...gasRegistration,
  // 服務聯繫
  ...serviceContact,
  // 公設資訊
  ...publicFacility
}
